"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButtonStyles = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var commons_1 = require("../../../style/commons");
var containedBaseStyles = function (bgHover, color, backgroundColor, bgSelected, bgLineHover) {
    if (color === void 0) { color = 'white'; }
    if (backgroundColor === void 0) { backgroundColor = 'none'; }
    if (bgSelected === void 0) { bgSelected = 'none'; }
    if (bgLineHover === void 0) { bgLineHover = 'none'; }
    return ({
        color: color,
        height: 40,
        backgroundColor: backgroundColor,
        fontSize: 16,
        paddingLeft: 16,
        paddingTop: 8,
        paddingBottom: 8,
        paddingRight: 16,
        borderRadius: 4,
        lineHeight: 0,
        '&:hover': {
            backgroundColor: bgHover,
            borderColor: bgLineHover,
        },
        '&:active': {
            backgroundColor: bgSelected,
        },
    });
};
exports.useButtonStyles = (0, styles_1.makeStyles)(function () { return ({
    root: {
        textTransform: 'none',
    },
    small: { minWidth: function (props) { return props.minWidth; } },
    medium: { minWidth: function (props) { return props.minWidth; } },
    fullWidth: { minWidth: '100%' },
    span: {
        textAlign: 'center',
        height: 10,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    containedPrimary: tslib_1.__assign({}, containedBaseStyles('none', 'white', commons_1.brandPrimaryExtraDark, commons_1.darkPrimary)),
    containedSecondary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.secondaryColor, commons_1.darkPrimary, commons_1.lightSecondary, commons_1.secondaryColor, commons_1.secondaryLineHover)), { border: '1px solid', borderColor: commons_1.darkPrimary }),
    containedTertiary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.secondaryColor, commons_1.darkPrimary, commons_1.lightSecondary, commons_1.darkSecondary)), { border: '1px solid transparent', backgroundColor: 'transparent', '&:hover': {
            backgroundColor: commons_1.secondaryHover,
            borderColor: commons_1.secondaryLineHover,
            border: '1px solid',
        } }),
    containedWarning: tslib_1.__assign({}, containedBaseStyles(commons_1.mediumWarning, 'white', commons_1.warningColor, commons_1.darkWarning)),
    containedError: tslib_1.__assign({}, containedBaseStyles(commons_1.lightDanger, 'white', commons_1.dangerColor, commons_1.darkDanger)),
    textPrimary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.primaryColor, commons_1.primaryColor, '', '')), { '&:hover': {
            color: commons_1.white,
            backgroundColor: commons_1.primaryColor,
        } }),
    textSecondary: tslib_1.__assign(tslib_1.__assign({}, containedBaseStyles(commons_1.secondaryColor, commons_1.darkPrimary, commons_1.lightSecondary, commons_1.secondaryColor, commons_1.secondaryLineHover)), { border: '1px solid transparent', '&:hover': {
            borderColor: commons_1.darkPrimary,
            border: '1px solid',
        } }),
    textTertiary: tslib_1.__assign({}, containedBaseStyles(commons_1.lightBlue, commons_1.mediumLightBlue, '', '')),
    containedSizeSmall: {
        fontSize: 14,
        height: 32,
    },
    textSizeSmall: {
        fontSize: 14,
        height: 32,
    },
    disabledContainedPrimary: {
        opacity: '0.4',
        backgroundColor: "".concat(commons_1.primaryColor, " !important"),
        color: 'white !important',
    },
    disabledContainedSecondary: {
        opacity: '0.4',
        borderColor: '#7373FC',
        backgroundColor: "".concat(commons_1.white, " !important"),
        color: "".concat(commons_1.mediumSecondary, " !important"),
    },
    disabledContainedTertiary: {
        opacity: '0.4',
        backgroundColor: "".concat(commons_1.white, " !important"),
        color: "".concat(commons_1.mediumSecondary, " !important"),
    },
    disabledTextPrimary: {
        opacity: '0.4',
        color: "".concat(commons_1.mediumGreen, " !important"),
    },
    disabledTextSecondary: {
        opacity: '0.4',
        color: "".concat(commons_1.brandPrimaryMaxDark, " !important"),
    },
    disabledTextTertiary: {
        opacity: '0.4',
        color: "".concat(commons_1.mediumLightBlue, " !important"),
    },
}); });
